"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContentService = void 0;
const graphql_request_1 = require("graphql-request");
const contentServiceQuery_1 = require("./graph/queries/contentServiceQuery");
const axios_1 = __importDefault(require("axios"));
const uuid_1 = require("uuid");
class WebContentService {
    constructor(environment) {
        this.client = new graphql_request_1.GraphQLClient(this.getUrlBasedOnEnvironment(environment) + '/content-graphql-service/graphql', {
            headers: {
                'client-name': 'ct-web-content-service'
            }
        });
    }
    fetchData(locale, content, client_id, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const transactionId = (0, uuid_1.v4)();
            try {
                const variables = { locale, content };
                const context = {
                    'transaction_id': transactionId,
                    'client_id': `${client_id}-content-service`,
                };
                const data = yield this.client.request(contentServiceQuery_1.ContentServiceQuery, variables, context);
                const url = data.staticContent.url;
                const response = yield axios_1.default.get(`/pubcontent${url}`);
                return response.data;
            }
            catch (error) {
                throw new Error(`Failed to fetch JSON: ${error}`);
            }
        });
    }
    fetchExceptionData(locale, client_id, loginStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            const transactionId = (0, uuid_1.v4)();
            try {
                const variables = {
                    locale,
                    contentType: "ExceptionMessaging",
                    subType: "",
                    loginStatus: loginStatus,
                    isHomePage: "True",
                    max: 5,
                    treatmentCodes: [],
                    min: 1,
                };
                const context = {
                    'transaction_id': transactionId,
                    'client_id': `${client_id}-content-service`,
                };
                return yield this.client.request(contentServiceQuery_1.ExceptionMessageQuery, variables, context);
            }
            catch (error) {
                throw new Error(`Failed to fetch JSON: ${error}`);
            }
        });
    }
    getUrlBasedOnEnvironment(environment) {
        let graphURL = 'https://qa.services.aa.com';
        if (environment === 'prod') {
            graphURL = 'https://services.aa.com';
        }
        else if (environment === 'stage') {
            graphURL = 'https://stage.services.aa.com';
        }
        return graphURL;
    }
}
exports.WebContentService = WebContentService;
